export const OTP_SESSION_KEYS = {
  challengeId: 'otp_challenge_id',
  expiresAt: 'otp_expires_at',
  resendAvailableAt: 'otp_resend_available_at',
};

export const OTP_RESEND_COOLDOWN_SECONDS = 60;
export const ONE_SECOND_MS = 1000;
export const OTP_DATE_STORAGE_FORMAT_REPLACEMENT = 'T';

export function isOtpRequiredLoginPayload(payload) {
  return (
    payload?.status === 200 &&
    payload?.data?.data?.requires_otp === true &&
    typeof payload?.data?.data?.challenge_id === 'string' &&
    payload.data.data.challenge_id.length > 0
  );
}

export function parseOtpDate(value) {
  if (!value) {
    return null;
  }

  const parsed = new Date(String(value).replace(' ', OTP_DATE_STORAGE_FORMAT_REPLACEMENT));
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  return parsed;
}

export function toIsoString(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return null;
  }

  return date.toISOString();
}

export function buildResendAvailableAt(now = new Date()) {
  return toIsoString(new Date(now.getTime() + OTP_RESEND_COOLDOWN_SECONDS * ONE_SECOND_MS));
}

export function secondsUntil(targetDateValue, now = new Date()) {
  const parsed = parseOtpDate(targetDateValue);
  if (!parsed) {
    return 0;
  }

  const diffMs = parsed.getTime() - now.getTime();
  if (diffMs <= 0) {
    return 0;
  }

  return Math.ceil(diffMs / ONE_SECOND_MS);
}

export function persistOtpChallenge(challengeId, expiresAt, resendAvailableAt = buildResendAvailableAt()) {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  sessionStorage.setItem(OTP_SESSION_KEYS.challengeId, challengeId);
  sessionStorage.setItem(OTP_SESSION_KEYS.expiresAt, expiresAt || '');
  sessionStorage.setItem(OTP_SESSION_KEYS.resendAvailableAt, resendAvailableAt || '');
}

export function clearOtpChallengeStorage() {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  sessionStorage.removeItem(OTP_SESSION_KEYS.challengeId);
  sessionStorage.removeItem(OTP_SESSION_KEYS.expiresAt);
  sessionStorage.removeItem(OTP_SESSION_KEYS.resendAvailableAt);
}

export function loadOtpChallenge() {
  if (typeof sessionStorage === 'undefined') {
    return { challengeId: null, expiresAt: null, resendAvailableAt: null };
  }
  return {
    challengeId: sessionStorage.getItem(OTP_SESSION_KEYS.challengeId),
    expiresAt: sessionStorage.getItem(OTP_SESSION_KEYS.expiresAt),
    resendAvailableAt: sessionStorage.getItem(OTP_SESSION_KEYS.resendAvailableAt),
  };
}

export function isOtpChallengeExpired(expiresAt, now = new Date()) {
  const parsed = parseOtpDate(expiresAt);
  if (!parsed) {
    return false;
  }

  return parsed.getTime() <= now.getTime();
}

export function getOtpRemainingSeconds(expiresAt, now = new Date()) {
  return secondsUntil(expiresAt, now);
}

export function getResendRemainingSeconds(resendAvailableAt, now = new Date()) {
  return secondsUntil(resendAvailableAt, now);
}
